module.exports = __webpack_public_path__ + "img/tu6.fad19c91.png";